import { t } from 'i18next';

import * as apiArchive from 'api/baseIngredient/DeleteBaseIngredientIdV1';
import * as apiRestore from 'api/baseIngredient/PostBaseIngredientRestoreV1';
import { Characteristic } from 'enums/characteristic';
import * as AllergenList from 'types/BaseIngredient/Search/AllergenList';
import * as CategoryList from 'types/BaseIngredient/Search/BaseIngredientCategoryList';
import * as NutriScore from 'types/BaseIngredient/Search/NutriScore';
import * as SeasonList from 'types/BaseIngredient/Search/SeasonList';
import * as TagList from 'types/BaseIngredient/Search/TagList';
import * as Co2Label from 'types/Co2/Co2Label';
import * as Icon from 'types/Icon/Icon';
import * as IconList from 'types/Icon/IconList';
import * as Image from 'types/Media/Image';

export type Type = {
	allergens: AllergenList.Type;
	calories: number | null;
	carbonDioxideLabel: Co2Label.Type;
	carbonDioxideValue: number | null;
	categories: CategoryList.Type;
	characteristic: Characteristic;
	countOfIngredients: number;
	density: number | null;
	hasNutriScore: boolean;
	id: string;
	image: Image.Type | null;
	lastEditedDateUtc: string;
	lastEditor: string | null;
	name: string;
	nutriScore: NutriScore.Type;
	seasons: SeasonList.Type;
	tags: TagList.Type;
};

export function create(): Type {
	return {
		allergens: AllergenList.create(),
		calories: null,
		carbonDioxideLabel: Co2Label.create(),
		carbonDioxideValue: null,
		categories: CategoryList.create(),
		characteristic: Characteristic.SolidNonQuantifiable,
		countOfIngredients: 0,
		density: null,
		hasNutriScore: false,
		id: '',
		image: null,
		lastEditedDateUtc: '',
		lastEditor: null,
		name: '',
		nutriScore: NutriScore.create(),
		seasons: SeasonList.create(),
		tags: TagList.create(),
	};
}

export function getIcons(obj: Type, allergensUserSet: Set<string>): IconList.Type {
	const output: (Icon.Type | null)[] = [];
	output.push(...TagList.mapToIcons(obj.tags));
	output.push(...AllergenList.mapToIcons(obj.allergens, allergensUserSet));
	return output.filter((x) => x?.iconSvgUrl).map((x) => x as Icon.Type);
}

export function getAuthor(obj: Type): string {
	if (obj.lastEditor) return obj.lastEditor;
	return t('_general:UNKNOWN_AUTHOR');
}

export async function callApiArchive(id: string): Promise<void> {
	await apiArchive.callApi(id);
}

export async function callApiRestore(id: string): Promise<void> {
	await apiRestore.callApi(id);
}
